/**
 * Lọc bỏ các param undefined, null, empty string
 * @param params - Object chứa parameters
 * @returns Object đã được lọc
 */
export const filterParams = (params: Record<string, any>): Record<string, string> => {
  return Object.fromEntries(
    Object.entries(params).filter(([_, value]) => 
      value !== undefined && 
      value !== null && 
      value !== '' &&
      value !== 'undefined' &&
      value !== 'null'
    )
  ) as Record<string, string>;
};

/**
 * Tạo query string từ params đã được lọc
 * @param params - Object chứa parameters
 * @returns Query string
 */
export const createQueryString = (params: Record<string, any>): string => {
  const filteredParams = filterParams(params);
  return new URLSearchParams(filteredParams).toString();
}; 